import React from 'react';
import Layout from '../../components/Shared/Layout';
import Raven from '../../components/Portfolio/raven';
import '../../assets/css/sesame.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class RavenPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/raven',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <Raven />
      </Layout>
    );
  }
}

export default RavenPage;
